/* eslint-disable no-unused-vars */
/* global React */
import { Grid } from '@mui/material'
import { useNetInfo, useStyles } from '@platform/react/hook'
import Icon from 'ui/Element/Icon'

const styles = (theme, { fullWidth }) => ({
  root: {
    display: 'flex',
    position: 'relative',
    width: fullWidth ? '100%' : 'auto',
  },
  iconContainer: {
    width: 18,
    height: 18,
    position: 'absolute',
    left: -4,
    top: -4,
    zIndex: 20,
    borderRadius: 50,
  },
  icon: {
    margin: -1,
  },
})

/**
 * Offline HoC
 *
 * Wraps `Component` and, if `disabledWhenOffline` is `true`, sets its prop with name
 * `disabledPropName` as `true` whenever the application loses its internet connectivity.
 * Optionally, if `hideOfflineIcon` is `false`, it also displays an exclamation icon above
 * `Component`.
 *
 * @param {Function} Component
 * @param {string} Component.displayName
 * @returns {function(*, *)}
 */
const OfflineHOC = Component => (props) => {
  const {
    disabledWhenOffline,
    disabledPropName = 'disabled',
    hideOfflineIcon,
    fullWidth = true,
    ...componentProps
  } = props

  const [online] = useNetInfo()
  const isButton = Component.displayName === 'Button'
  const classes = useStyles(styles, { fullWidth: isButton && fullWidth })()

  return disabledWhenOffline ? (
    <Grid
      item
      container
      className={classes.root}
    >
      {!online && !hideOfflineIcon && (
        <Grid
          item
          className={classes.iconContainer}
        >
          <Grid
            item
            component={Icon}
            name={'error-codes'}
            color={'white'}
            background={'warning'}
            className={classes.icon}
            size={20}
          />
        </Grid>
      )}
      <Component
        {...componentProps}
        {...{
          [disabledPropName]: online
            ? componentProps[disabledPropName]
            : true,
        }}
        {...isButton && {
          fullWidth,
        } }
      />
    </Grid>
  ) : (
    <Component
      {...componentProps}
      {...isButton && {
        fullWidth,
      } }
    />
  )
}

export default OfflineHOC
